import { Typography } from "@mui/material";
import { EventType } from "@/hooks/client/useClientPortalPaymentPlansMixpanelEvents";
import PaymentPlanSliderCard, {
  PaymentPlanCardBaseProps,
} from "./paymentPlanSliderCard";

export default function LearnMoreCard({ ...props }: PaymentPlanCardBaseProps) {
  return (
    <PaymentPlanSliderCard
      cardProps={{
        title: <Typography variant="h2">Not sure yet?</Typography>,
        description:
          "You can talk to your provider about these options in your appointment. There is no obligation or commitment required.",
      }}
      buttonProps={{
        copy: "I'm interested to learn more",
      }}
      actionProps={{
        eventType: EventType.LEARN_MORE_ABOUT_PAYMENT_PLANS_CLICKED,
        shouldShowToast: true,
        ...props,
      }}
    />
  );
}
